import React, { useState } from "react";
import { BasketItem, Branch } from "../../containers/NewOrderContainer/types";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import DeleteIcon from "@material-ui/icons/Delete";

import "./BasketList.scss";
import { Checkbox } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import WarningIcon from "@material-ui/icons/Warning";

const BasketList = (props: any) => {
  const [selectedItems, setSelectedItems] = useState<BasketItem[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);

  function getBranchName(item: BasketItem): string {
    const branch = props.branches.find((b: Branch) => b.id === item.branchId);
    if (branch) {
      return branch.name;
    }
    return "";
  }

  function handleDeleteButtonClick() {
    setOpenModal(true);
  }

  function handleConfirmDeleteClick() {
    if (selectedItems.length > 0) {
      props.onDeleteFromBasket(selectedItems);
      setSelectAllChecked(!selectAllChecked);
      setSelectedItems([]);
    }
    setOpenModal(false);
  }

  return (
    <div className="BasketList-mainContainer">
      <div className="BasketList-headerBar">
        {props.returns ? (
          <div className="BasketList-headerContainer">
            <b>Return Basket</b>
            <div className="BasketList-warningContainer">
              <WarningIcon className="BasketList-indicativeWarning" />
              <div>
                All rates for returns are indicative only. The exact rate will
                be applied when the return is processed.
              </div>
            </div>
          </div>
        ) : (
          <div className="BasketList-headerContainer">
            <b>Order Basket</b>
          </div>
        )}
      </div>
      <table className="BasketList-container">
        <thead className="BasketList--headPanel">
          <tr className="BasketList--headPanelRow">
            <th>
              <Checkbox
                disabled={props.items && props.items.length === 0}
                className="BasketList-selectAll"
                inputProps={{ "aria-label": "primary checkbox" }}
                checked={selectAllChecked}
                onChange={event => {
                  setSelectAllChecked(!selectAllChecked);
                  if (event.target.checked) {
                    setSelectedItems(props.items);
                  } else {
                    setSelectedItems([]);
                  }
                }}
              />
            </th>
            <th>Branch Name</th>
            <th>Currency</th>
            <th>Currency Amount</th>
            <th>Exchange Rate</th>
            <th>Traveller/Beneficiary</th>
            <th>Required</th>
            <th>Settlement</th>
          </tr>
        </thead>
        <tbody className="BasketList-tableBody">
          {props.items &&
            props.items.map((item: BasketItem) => (
              <tr className="NewOrder--basket-row">
                <td className="BasketItem-selectBasketItem">
                  <Checkbox
                    className="BasketItem-selectBasketItemCheckBox"
                    inputProps={{ "aria-label": "primary checkbox" }}
                    checked={selectedItems.includes(item)}
                    onChange={event => {
                      if (event.target.checked) {
                        setSelectedItems(() => [...selectedItems, item]);
                      } else {
                        setSelectedItems((basketItem: BasketItem[]) => {
                          const result = [...basketItem];
                          if (result.indexOf(item) !== -1) {
                            result.splice(result.indexOf(item), 1);
                          }
                          return result;
                        });
                      }
                    }}
                  />
                </td>
                <td className="BasketItem-branchName">{getBranchName(item)}</td>
                <td className="BasketItem-currency">{item.currency}</td>
                <td className="BasketItem-currencyAmount">
                  {item.currencyAmount
                    .toLocaleString(navigator.language, {
                      minimumFractionDigits: 2
                    })
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </td>
                <td className="BasketItem-exchangeRate">
                  {item.exchangeRate && item.exchangeRate.toFixed(4)}
                </td>
                <td className="BasketItem-travellerBeneficiary">
                  {item.travellerBeneficiary}
                </td>
                <td className="BasketItem-required">{item.required}</td>
                <td className="BasketItem-settlement">{item.settlement}</td>
              </tr>
            ))}
        </tbody>
      </table>
      {selectedItems.length > 0 ? (
        <div className="BasketList-actionBar">
          <Button
            className="BasketList-deleteSelectedButton"
            variant="contained"
            color="secondary"
            startIcon={<DeleteIcon />}
            onClick={handleDeleteButtonClick}
          >
            Delete selected
          </Button>
        </div>
      ) : (
        <></>
      )}
      {props.items && props.items.length === 0 ? (
        <div className="BasketList--noDataContainer">
          <ShoppingBasketIcon className="BasketList--noDataIcon" />
          <p className="BasketList--noDataText">
            There are currently no items in the basket.
          </p>
        </div>
      ) : (
        <></>
      )}
      <Dialog
        className="BasketList-confirmationDialog"
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Delete Selected Items"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete{" "}
            {selectedItems.length > 1 ? "these " : "this "}
            <b>{selectedItems.length}</b> selected basket{" "}
            {selectedItems.length > 1 ? "items" : "item"}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="BasketList-confirmationDialogCancel"
            onClick={() => setOpenModal(false)}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            className="BasketList-confirmationDialogConfirm"
            onClick={handleConfirmDeleteClick}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BasketList;
